import { STORE_PARTY_ROLES } from '../../constants/actionTypes'

const initialState = {}

const sort = roles =>
  roles.slice().sort((a, b) => (a.display_name < b.display_name ? -1 : 1))

const rolesReducer = (state = initialState, action) => {
  switch (action.type) {
    case STORE_PARTY_ROLES:
      return Object.assign({}, state, { content: sort(action.content) })
    default:
      return state
  }
}

export default rolesReducer
